export default __webpack_public_path__ + "static/media/FigureImage.91213512.jpg";